<template>
  <v-dialog
    :max-width="maxWidth"
    v-model="show"
    persistent
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Nueva Evolucion</v-toolbar-title>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="7" md="4">
              <v-select
                :items="profsBuscar"
                item-text="nombreProfesional"
                item-value="idProfesional"
                menu-props="auto"
                label="Profesional *"
                hide-details
                prepend-icon="mdi-account"
                v-model="prof"
                dense
                no-data-text="No hay Profesionales configurados"
              ></v-select>
            </v-col>
            <v-spacer></v-spacer>
            <v-col v-if="plantillasEvolucion.length" cols="12" sm="7" md="3">
              <v-select
                :items="plantillasEvolucion"
                item-text="nombrePlantilla"
                item-value="idPlantillaEvolucion"
                menu-props="auto"
                label="Plantillas Evolucion"
                hide-details
                prepend-icon="mdi-hospital"
                v-model="plantillaEvolucion"
                dense
                no-data-text="No hay Plantillas configuradas"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="7" md="4">
              <v-text-field
                v-model="fecha"
                :value="fecha"
                label="Fecha *"
                :rules="requiredRules"
                prepend-icon="mdi-calendar"
                type="date"
                dense
                :disabled="
                  $store.state.usuario.institucion.idInstitucion === 270
                "
              ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-col v-if="!plantillaEvolucion" cols="12" sm="4" md="2">
              <v-switch
                dense
                v-model="usaEditorAvanzado"
                label="Habilita editor avanzado"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row v-if="$store.state.usuario.institucion.idInstitucion === 436">
            <v-col cols="12" sm="7" md="4">
              <v-checkbox
                v-model="controlNinoSano"
                label="Es control de niño sano"
                color="primary"
                dense
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row dense v-if="!plantillaEvolucion">
            <v-col cols="12">
              <v-textarea
                v-if="!usaEditorAvanzado"
                prepend-icon="mdi-hospital"
                v-model="evolucion"
                label="Evolucion *"
                :rules="requiredRules"
                clearable
                auto-grow
              ></v-textarea>
              <vue-editor
                v-else
                v-model="evolucion"
                :editor-toolbar="customToolbar"
              />
            </v-col>
          </v-row>
          <component
            v-else
            :is="asyncComponent"
            :faltan-campos-requeridos.sync="faltanCamposRequeridos"
            @actualizaEvolucionJson="onActualizaEvolucionJson"
          />
        </v-card-text>
        <v-card-actions>
          <h4 v-if="this.$store.state.usuario.institucion.idInstitucion === 32">
            Obs.: {{ paciente.observaciones }}
          </h4>
          <v-btn
            v-if="!$store.state.usuario.institucion.esEmpresa"
            color="warning"
            @click.stop="verDatosAfiliatorios"
            >Datos Afiliatiorios</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            :disabled="plantillaEvolucion ? faltanCamposRequeridos : !valid"
            @click.stop="guardarEvolucion"
            >Guardar</v-btn
          >
          <v-btn color="error" @click.stop="show = false">Salir</v-btn>
        </v-card-actions>
      </v-form>
      <VerDatosAfiliatorios
        :visible="showVerDatosAfiliatorios"
        :idPaciente="idPaciente"
        @close="showVerDatosAfiliatorios = false"
      />
    </v-card>
  </v-dialog>
</template>
<style scoped>
.v-dialog__content {
  align-items: left;
  justify-content: left;
}
</style>
<script>
import axios from "../../axios-auth.js";
import VerDatosAfiliatorios from "./VerDatosAfiliatorios.vue";
import { VueEditor } from "vue2-editor";

export default {
  data: (vm) => ({
    usaEditorAvanzado: null,
    valid: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    showVerDatosAfiliatorios: false,
    prof: "",
    profsBuscar: [],
    fecha: null,
    evolucion: "",
    maxWidth: "100%",
    plantillaEvolucion: 0,
    asyncComponent: null,
    plantillasEvolucion: [],
    evolucionJson: {},
    faltanCamposRequeridos: false,
    controlNinoSano: false,
    customToolbar: [
      [{ size: ["small", false, "large", "huge"] }], // tamaño de fuente
      ["bold", "italic", "underline", "strike"], // formato básico
      [
        { color: [] }, // color de texto
        { background: [] }, // color de fondo
      ],
    ],
  }),
  components: { VerDatosAfiliatorios, VueEditor },
  props: {
    visible: {
      required: true,
      type: Boolean,
    },
    idPaciente: {
      required: true,
    },
    paciente: {
      required: true,
    },
    esResultado: {
      required: false,
      default: false,
    },
  },
  computed: {
    show: {
      get() {
        if (this.visible) this.setearModels();
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          this.vaciarModels();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },
  watch: {
    plantillaEvolucion: {
      async handler(idPlantillaEvolucion) {
        if (idPlantillaEvolucion) {
          const nombre = this.plantillasEvolucion.find(
            (pl) => pl.idPlantillaEvolucion === idPlantillaEvolucion
          ).nombrePlantilla;
          const component = await import(
            `./PlantillasEvolucion/${this.$store.state.usuario.institucion.idInstitucion}/${nombre}.vue`
          );
          this.asyncComponent = component.default;
        }
      },
    },
    usaEditorAvanzado: {
      async handler(val) {
        await axios.get("/Usuario/SetUsaEditorAvanzado", {
          params: {
            usuario: this.$store.state.usuario.usuario,
            usaEditorAvanzado: val,
          },
        });
        if (!val && !this.plantillaEvolucion) {
          if (this.esHTML(this.evolucion)) {
            this.evolucion = this.sanitizeToPlainText(this.evolucion);
          }
        }
      },
    },
  },
  methods: {
    esHTML(text) {
      return /<\/?[a-z][\s\S]*>/i.test(text);
    },
    sanitizeToPlainText(html) {
      if (!html) return "";

      // Crear un elemento temporal para usar el parser del navegador
      const temp = document.createElement("div");
      temp.innerHTML = html;

      // Reemplazar etiquetas de bloque con saltos de línea
      const blockTags = ["p", "div", "br", "li", "tr"];
      blockTags.forEach((tag) => {
        const elements = temp.getElementsByTagName(tag);
        for (let el of elements) {
          // Agregar salto de línea después de cada elemento de bloque
          el.insertAdjacentText("afterend", "\n");
        }
      });

      // Obtener solo el texto visible
      let text = temp.textContent || temp.innerText || "";

      // Limpiar múltiples saltos de línea o espacios
      text = text.replace(/\n\s*\n+/g, "\n").trim();

      return text;
    },
    onActualizaEvolucionJson(value) {
      if (value) {
        Object.assign(this.evolucionJson, value);
      }
    },
    verDatosAfiliatorios() {
      this.showVerDatosAfiliatorios = true;
    },
    guardarEvolucion() {
      this.$swal({
        title: "Registrar Evolucion",
        text: "¿Desea registrar la evolución?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          const datosEvolucion = {
            fechaHora: this.fecha,
            fechaHoraAlta: this.fecha,
            idPaciente: this.idPaciente,
            idProfesional: this.prof,
            texto: this.plantillaEvolucion ? "plantilla" : this.evolucion,
            esEmpresa: this.$store.state.usuario.institucion.esEmpresa,
            usaPlantilla: this.plantillaEvolucion,
            evolucionJson: this.plantillaEvolucion
              ? JSON.stringify(this.evolucionJson)
              : "texto",
            controlNinoSano: this.controlNinoSano,
          };
          let self = this;
          axios
            .post("/HistoriaClinica/GuardarEvolucion", datosEvolucion)
            .then((response) => {
              self.$refs.form.resetValidation();
              self.vaciarModels();
              document.getElementsByClassName(
                "v-dialog--active"
              )[0].scrollTop = 0;
              self.showAlert({
                icon: "success",
                title: "Evolución registrada exitosamente",
                vm: self,
              });
              self.$emit("evolucionRegistrada");
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title: "La evolución no pudo ser registrada",
                vm: this,
              });
            });
        }
      });
    },

    async setearModels() {
      const profData = {
        usuario: this.$store.state.usuario.usuario,
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };
      let self = this;
      axios
        .get("/Turnos/BuscarProfesionalesAsociados?", {
          params: {
            usuario: profData.usuario,
            idInstitucion: profData.idInstitucion,
          },
        })
        .then((response) => {
          self.profsBuscar = response.data.profesionales;

          self.prof =
            self.$store.state.indexProf || self.profsBuscar[0].idProfesional;
        });

      this.fecha = this.parseDate(this.formatDate(this.toISOLocal(new Date())));
      if (this.$store.state.videollamada == true) this.maxWidth = "68%";
      else this.maxWidth = "100%";

      const { data: plantillasEvolucion = [] } = await axios.get(
        "/HistoriaClinica/GetPlantillasEvolucion",
        {
          params: {
            idInstitucion: profData.idInstitucion,
          },
        }
      );
      this.plantillasEvolucion = plantillasEvolucion;
      if (this.plantillasEvolucion.length && !this.esResultado) {
        this.plantillasEvolucion.unshift({
          idPlantillaEvolucion: 0,
          nombrePlantilla: "Sin Plantilla",
        });
      }
      if (this.esResultado) {
        this.plantillaEvolucion =
          this.plantillasEvolucion[0].idPlantillaEvolucion;
      }

      const { data } = await axios.get("/Usuario/GetUsaEditorAvanzado", {
        params: {
          usuario: this.$store.state.usuario.usuario,
        },
      });
      this.usaEditorAvanzado = data;
    },

    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    toISOLocal(d) {
      var z = (n) => ("0" + n).slice(-2);
      var zz = (n) => ("00" + n).slice(-3);
      var off = d.getTimezoneOffset();
      var sign = off < 0 ? "+" : "-";
      off = Math.abs(off);
      return (
        d.getFullYear() +
        "-" +
        z(d.getMonth() + 1) +
        "-" +
        z(d.getDate()) +
        "T" +
        z(d.getHours()) +
        ":" +
        z(d.getMinutes()) +
        ":" +
        z(d.getSeconds()) +
        "." +
        zz(d.getMilliseconds()) +
        "Z"
      )
        .toString()
        .substr(0, 10);
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    vaciarModels() {
      this.evolucion = "";
      this.evolucionJson = {};
      this.controlNinoSano = false;
    },
    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 2000,
      });
    },
  },
};
</script>
